import Axios from "@/utils/Axios";
import config from "@/config";

export interface AlbumListParams {
  page_size: number;
  page_index: number;
}

export interface CreateAlbumParams {
  name: string;
}

export interface DeleteAlbumParams {
  id: number;
  type: number; //1 删除但保留画册内容， 2 连带画册内容一起删除
}

export interface RenameAlbumParams {
  id: number;
  name: string;
}

export interface AlbumDetailParams {
  id: number;
  page_size: number;
  page_index: number;
}

export interface AlbumMoveParams {
  album_id: number;
  to_album_id: number;
  album_image_ids: number[];
}

export interface AlbumRemovePicParams {
  album_id: number;
  album_image_ids: number[];
}

export interface ThumbsUpParams {
  image_id: number;
}

export interface PostAddAlbumType {
  meta_json: string;
  is_ai: 1 | 2;
  image_url: string;
  source: "board" | "finished";
  board_alias?: string;
  image_id?: number;
}
export interface PostImageAlbumType {
  type: "board" | "finished";
  image_id?: number;
  board_alias?: string;
}
export interface PostRemoveAlbumType {
  album_id: number;
  album_image_ids: number[];
}
export interface PostListAlbumsType {
  page_index: number;
  page_size: number;
}
export interface PostMoveAlbumType {
  album_id: number;
  to_album_id: number;
  album_image_ids: number[];
}

export interface GetPromptDetailParams {
  image_id: number;
}
// 相册增删改查
export function fetchAlbumList(data: AlbumListParams) {
  return Axios.post(`/list/albums`, data, {}, config.aiCreator);
}
export function renameAlbum(data: RenameAlbumParams) {
  return Axios.post(`/rename/album`, data, {}, config.aiCreator);
}
export function deleteAlbum(data: DeleteAlbumParams) {
  return Axios.post(`/remove/albums`, data, {}, config.aiCreator);
}
export function createAlbum(data: CreateAlbumParams) {
  return Axios.post(`/create/album`, data, {}, config.aiCreator);
}
// 获取相册图片
export function fetchAlbumDetail(data: AlbumDetailParams) {
  return Axios.post(`/get/album`, data, {}, config.aiCreator);
}
// 相册间移动图片
export function movePicsBetweenAlbums(data: AlbumMoveParams) {
  return Axios.post(`/move/album`, data, {}, config.aiCreator);
}
// 删除某相册图片
export function deleteAlbumPic(data: AlbumRemovePicParams) {
  return Axios.post("/remove/album", data, {}, config.aiCreator);
}
// 图片点赞
export function thumbsUp(data: ThumbsUpParams, cancel = false) {
  return Axios.post(`${cancel ? "/likes/cancel" : "/likes/add"}`, data, {}, config.aiCreator);
}

// 加入画册-Post
export function postAddAlbum(data: PostAddAlbumType[]) {
  return Axios.post("/add/album", { album_image: data }, {}, config.creatorUrl);
}
// 图片所属画册-Post
export function postImageAlbum(data: PostImageAlbumType) {
  return Axios.post("/image/album", data, {}, config.creatorUrl);
}
// 移除画册图片-Post
export function postRemoveAlbum(data: PostRemoveAlbumType) {
  return Axios.post("/remove/album", data, {}, config.creatorUrl);
}
// 画册列表-Post
export function postListAlbums(data: PostListAlbumsType) {
  return Axios.post("/list/albums", data, {}, config.creatorUrl);
}
// 移动画册-Post
export function postMoveAlbum(data: PostMoveAlbumType) {
  return Axios.post("/move/album", data, {}, config.creatorUrl);
}
// 通过 alias 获取图片在画册中的信息
export function getAlbumImageByAlias(board_alias: string) {
  return Axios.post("/check/image", { board_alias }, {}, config.creatorUrl);
}
// album check
export function checkAlbum() {
  return Axios.post("/check/album", {}, {}, config.creatorUrl);
}

export function getPromptDetail(data: GetPromptDetailParams) {
  return Axios.post(`/prompt/detail`, data, {}, config.aiCreator);
}

// 检查图片是否存在
export function checkImagesInAlbum(aliases: string[]) {
  return Axios.post("batch_check/image", { board_alias: aliases }, {}, config.creatorUrl);
}
